module.exports = __webpack_public_path__ + "img/icon-training.82847c68.svg";